import { Component, ElementRef, HostListener, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { SidebarService } from './sidebar.service';
import { MenuItem } from 'primeng/api';
import { LoginService } from 'src/app/modules/login/login.service';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PanelMenu } from 'primeng/panelmenu';
import { TasksService } from 'src/app/modules/tasks/_services/tasks.service';
import { IParamsCollection } from '../jsonapi/interfaces/params-collection';
import { FilterBuilder } from '../jsonapi/filters-builder';
import { LocalStorageService } from 'angular-web-storage';
import { AndFilter, Filter, FilterOperation, OrFilter } from '../jsonapi/filter';
import { firstValueFrom } from 'rxjs';
import { MailAccountsService } from 'src/app/modules/comunications/_services/mail-account.service';
import { ContractProcessorsService } from 'src/app/modules/companies/_services/contracts-processors.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SidebarComponent {

  @ViewChildren(PanelMenu)
  public menus!: QueryList<PanelMenu>;

  public sections: { label?: string, items: MenuItem[] }[] = [];
  public bottomItems: MenuItem[] = [];

  private readonly sectionLayout: { label?: string, ids: string[] }[] = [
    { ids: ['nav-home'] },
    { label: 'Operativa', ids: ['nav-assistance', 'nav-tasks', 'nav-voip'] },
    { label: 'Gestión', ids: ['nav-providers', 'nav-billing', 'nav-reports', 'nav-use'] },
    { label: 'Sistema', ids: ['nav-developer', 'nav-settings'] },
  ];
  private readonly bottomIds: string[] = ['nav-help', 'nav-logout'];

  public pendingTasksCount: number = 0;
  public unseanMails: number = 0;

  public items: MenuItem[] = [
    { id: 'nav-home', label: 'Inicio', icon: 'pi pi-home', link: '/home', command: () => this.collapseAll() },
    //{ label: 'Inicio Tramitador', icon: 'pi pi-home', routerLink: '/homeProcessor', command: () => this.collapseAll() },
    {
      id: 'nav-assistance', label: 'Asistencia', icon: 'pi pi-globe', items: [
        { label: 'Planificación', icon: 'pi pi-calendar-clock', routerLink: '/cases/planification', command: () => { this.collapseAll(); }, visible: this.loginService.hasPermission('CASES.ACCESS') },
        { label: 'Expedientes', icon: 'pi pi-clipboard', routerLink: '/cases', command: () => { this.collapseAll(); }, visible: this.loginService.hasPermission('CASES.ACCESS') },
        { label: 'Siniestros Graves', icon: 'pi pi-exclamation-triangle', routerLink: '/serious-cases', command: () => { this.collapseAll(); }, visible: this.loginService.hasPermission('CASES.ACCESS') },
        { label: 'Servicios pendientes de confirmar', icon: 'pi pi-check-square', routerLink: '/cases-pending-approval', command: () => { this.collapseAll(); }, visible: this.loginService.hasPermission('CASES.PENDING_APPROVAL') },
        { label: 'Tipos de expedientes', icon: 'pi pi-clipboard', routerLink: '/casesTypes', command: () => this.collapseAll(), visible: this.loginService.hasPermission('CASES_TYPES.ACCESS') },
        { label: 'Clientes', icon: 'pi pi-user', routerLink: '/clients', command: () => this.collapseAll(), visible: this.loginService.hasPermission('CLIENTS.ACCESS') },
        { label: 'Compañías', icon: 'pi pi-building', routerLink: '/companies', command: () => this.collapseAll(), visible: this.loginService.hasPermission('COMPANIES.ACCESS') },
        { label: 'Coberturas', icon: 'pi pi-shield', routerLink: '/guarantees', command: () => this.collapseAll(), visible: this.loginService.hasPermission('GUARANTEES.ACCESS') },
        { label: 'Peritos', icon: 'pi pi-user', routerLink: '/experts', command: () => this.collapseAll(), visible: this.loginService.hasPermission('EXPERTS.ACCESS') },
        { label: 'Mediadores', icon: 'pi pi-user', routerLink: '/mediators', command: () => this.collapseAll(), visible: this.loginService.hasPermission('MEDIATORS.ACCESS') },
        { label: 'Compañías aseguradoras', icon: 'pi pi-shield', routerLink: '/insuranceCompanies', command: () => this.collapseAll(), visible: this.loginService.hasPermission('INSURANCE_COMPANIES.ACCESS') },
        { id: 'menu-mailbox', label: 'Buzones de correo', icon: 'pi pi-envelope', routerLink: '/mailboxes', command: () => { this.collapseAll(); }, badge: '' + this.unseanMails, badgeStyleClass: 'warn', visible: this.loginService.hasPermission('MAILBOX.ACCESS') },
      ]
    },
    {
      id: 'nav-providers', label: 'Proveedores', icon: 'pi pi-building',
      items: [
        { label: 'Proveedores', icon: 'pi pi-building', routerLink: '/providers', command: () => this.collapseAll(), visible: this.loginService.hasPermission('PROVIDERS.ACCESS') },
        { label: 'Operarios', icon: 'pi pi-user', routerLink: '/workers', command: () => this.collapseAll(), visible: this.loginService.hasPermission('WORKERS.ACCESS') },
        { label: 'Calendarios', icon: 'pi pi-calendar', routerLink: '/calendars', command: () => this.collapseAll(), visible: this.loginService.hasPermission('CALENDARS.ACCESS') },
        { label: 'Turnos de guardia', icon: 'pi pi-calendar', routerLink: '/guards-shifts', command: () => this.collapseAll(), visible: this.loginService.hasPermission('GUARDS_SHIFTS.ACCESS') },
        { label: 'Solicitudes de compra', icon: 'pi pi-receipt', routerLink: '/transactions/purchase_order', command: () => this.collapseAll(), visible: this.loginService.hasPermission('PURCHASE_ORDER.ACCESS') },
      ]
    },
    {
      id: 'nav-billing', label: 'Facturación', icon: 'pi pi-euro', 
      items: [
        {
          label: 'Albaranes a companía', icon: 'pi pi-file-edit', routerLink: '/transactions/company_outgoing_delivery_note', command: () => this.collapseAll(), visible: this.loginService.hasPermission('COMPANY_OUTGOING_DELIVERY_NOTE.ACCESS')
        },
        {
          label: 'Facturas a companía', icon: 'pi pi-file-check', routerLink: '/transactions/company_outgoing_invoice', command: () => this.collapseAll(), visible: this.loginService.hasPermission('COMPANY_OUTGOING_INVOICE.ACCESS')
        },
        {
          label: 'Facturas a cliente', icon: 'pi pi-file-check', routerLink: '/transactions/outgoing_invoice', command: () => this.collapseAll(), visible: this.loginService.hasPermission('OUTGOING_INVOICE.ACCESS')
        },        
        {
          label: 'Retenciones de obra', icon: 'pi pi-file-check', routerLink: '/transactions-retentions', command: () => this.collapseAll(), visible: this.loginService.hasPermission('COMPANY_OUTGOING_INVOICE.ACCESS')
        },
        /*{
          label: 'Pedidos a proveedores', icon: 'pi pi-receipt', routerLink: '/transactions/outgoing_order', command: () => this.collapseAll(), visible: this.loginService.hasPermission('OUTGOING_ORDERS.ACCESS')
        },*/
        {
          label: 'Facturas de operario', icon: 'pi pi-file-check', routerLink: '/transactions/incoming_invoice', command: () => this.collapseAll(), visible: this.loginService.hasPermission('INCOMING_INVOICE.ACCESS')
        },
        {
          label: 'Dev. económicas cliente', icon: 'pi pi-file-check', routerLink: '/transactions/client_compensation', command: () => this.collapseAll(), visible: this.loginService.hasPermission('CLIENT_COMPENSATION.ACCESS')
        },
        /*{
          label: 'Anticipos', icon: 'pi pi-file-check', routerLink: '/transactions/worker_invoice_request', command: () => this.collapseAll(), visible: this.loginService.hasPermission('WORKER_INVOICE_REQUEST.ACCESS')
        },*/
        {
          label: 'Bonificaciones', icon: 'pi pi-file-check', routerLink: '/transactions/bonus_invoice', command: () => this.collapseAll(), visible: this.loginService.hasPermission('BONUS_INVOICE.ACCESS')
        },
        {
          label: 'Conceptos facturables', icon: 'pi pi-file-check', routerLink: '/transactions/worker-billable-items-lines', command: () => this.collapseAll(), visible: this.loginService.hasPermission('WORKER_BILLABLE_ITEMS_LINES.ACCESS')
        },
      ]
    },
    {
      id: 'nav-tasks', label: 'Tareas', icon: 'pi pi-clipboard', items: [
        { id: 'menu-tasks', label: 'Tareas', icon: 'pi pi-pen-to-square', routerLink: '/tasks', command: () => this.collapseAll(), visible: this.loginService.hasPermission('TASKS.ACCESS'), badge: '' + this.pendingTasksCount, badgeStyleClass: 'warn' },
        { label: 'Notificaciones', icon: 'pi pi-bell', routerLink: '/notifications', command: () => this.collapseAll(), visible: this.loginService.hasPermission('NOTIFICATIONS.ACCESS') },
      ]
    },
    {
      id: 'nav-voip', label: 'Centralita', icon: 'pi pi-phone',
        visible: this.loginService.hasPermission('VOIP.STATUS_ACCESS') || this.loginService.hasPermission('VOIP.SCHEDULE_ACCESS') || this.loginService.hasPermission('VOIP.EXTENSIONS_ACCESS') || this.loginService.hasPermission('VOIP.CDR_ACCESS') || this.loginService.hasPermission('VOIP.QUEUES_ACCESS') || this.loginService.hasPermission('VOIP.DIALPLAN_ACCESS') || this.loginService.hasPermission('VOIP.DDIS_ACCESS'),
      items: [
        { label: 'Estado', icon: 'pi pi-globe', routerLink: '/voip/status', command: () => this.collapseAll(), visible: this.loginService.hasPermission('VOIP.STATUS_ACCESS') },
          { label: 'Horarios', icon: 'pi pi-calendar-clock', routerLink: '/voip/schedule-config', command: () => this.collapseAll(), visible: this.loginService.hasPermission('VOIP.SCHEDULE_ACCESS') },
        { label: 'Extensiones', icon: 'pi pi-phone', routerLink: '/voip/extensions', command: () => this.collapseAll(), visible: this.loginService.hasPermission('VOIP.EXTENSIONS_ACCESS') },
        { label: 'Colas', icon: 'pi pi-users', routerLink: '/voip/queues', command: () => this.collapseAll(), visible: this.loginService.hasPermission('VOIP.QUEUES_ACCESS') },
        { label: 'Planes de llamada', icon: 'pi pi-sitemap', routerLink: '/voip/dial-plans', command: () => this.collapseAll(), visible: this.loginService.hasPermission('VOIP.DIALPLAN_ACCESS') },
        { label: 'DDIs', icon: 'pi pi-phone', routerLink: '/voip/ddis', command: () => this.collapseAll(), visible: this.loginService.hasPermission('VOIP.DDIS_ACCESS') },
        { label: 'Llamadas', icon: 'pi pi-list', routerLink: '/voip/cdr', command: () => this.collapseAll(), visible: this.loginService.hasPermission('VOIP.CDR_ACCESS') },
      ]
    },
    {
      id: 'nav-reports', label: 'Informes', icon: 'pi pi-chart-line', link: '/reports', command: () => this.collapseAll(), visible: this.loginService.hasPermission('REPORTS.ACCESS')
    },
    {
      id: 'nav-developer', label: 'Developer', icon: 'pi pi-code',
      visible: this.loginService.hasPermission('DEVELOPER.DB_DIAGRAM_ACCESS') || this.loginService.hasPermission('DEVELOPER.DB_DOCUMENTATION_ACCESS'),
      items: [
        { label: 'Diagrama BD', icon: 'pi pi-database', command: () =>{
            let baseUrl = location.protocol + '//' + location.host;
            baseUrl = baseUrl.replace('.guai.','.api.guai.');
            baseUrl = baseUrl.replace('.guai-dev.','.api.guai-dev.');
            this.goToUrl(baseUrl + '/api/reporting/database/diagram');
          }, 
          visible: this.loginService.hasPermission('DEVELOPER.DB_DIAGRAM_ACCESS')
        },
        { label: 'Diccionario de datos', icon: 'pi pi-book', command: () => {
            let baseUrl = location.protocol + '//' + location.host;
            baseUrl = baseUrl.replace('.guai.','.api.guai.');
            baseUrl = baseUrl.replace('.guai-dev.','.api.guai-dev.');
            this.goToUrl(baseUrl + '/api/reporting/database/documentation/pdf');
          }, 
          visible: this.loginService.hasPermission('DEVELOPER.DB_DOCUMENTATION_ACCESS') }
      ]
    },
    { id: 'nav-use', label: 'Consumo', icon: 'pi pi-calculator', link: '/use',visible: this.loginService.hasPermission('USE.ACCESS'), command: () => this.collapseAll() },
    {
      id: 'nav-settings', label: 'Configuración', icon: 'pi pi-cog', link: '/settings', command: () => this.collapseAll()
    },
    { id: 'nav-help', label: 'Centro de ayuda', icon: 'pi pi-question-circle', link: '/help-center', command: () => this.collapseAll() },
    { id: 'nav-logout', label: 'Cerrar sesión', icon: 'pi pi-sign-out', command: () => { this.collapseAll(); this.logout(); } },

  ];
  public hasLoadedProcessorContracts: boolean = false;
  public usersSameContractsIds: string[] = [];

  constructor(
    private router: Router,
    public sidebarService: SidebarService,
    private loginService: LoginService,
    private tasksService: TasksService,
    private storage: LocalStorageService,
    private mailAccountsService: MailAccountsService,
    private contractProcessorsService: ContractProcessorsService,
    private elementRef: ElementRef
  ) {
  }

  async ngOnInit() {
    
    //reviamos menus y macarmos como no vivibles las opciones que tiene visibles ningun item
    this.items.forEach((item: MenuItem) => {
      if (item.items) {
        item.visible = item.items.filter((subitem: MenuItem) => subitem.visible).length > 0;
      }
    });
    this.buildSections();

    this.loadTasks();
    if(this.loginService.hasPermission('MAILBOX.ACCESS')){
      this.loadMailAccounts();
    }
  }

   async loadProcessorContracts(){
    let user = this.storage.get('user');
    let filterP: any = {
      processorId: new Filter(FilterOperation.equals, 'processorId', '', user.id)
    };
    let paramsP:IParamsCollection = {
      filter: FilterBuilder.fromObject(filterP).build()
    };
    let responseP = await firstValueFrom(this.contractProcessorsService.all(paramsP));
    let processorContractIds = responseP.data.map(pc => pc.contractId);

    //los tramitadores de los mismos contratos que el usuario
    let filtersCases = {
      contractId: new Filter(FilterOperation.any, 'contractId', "", processorContractIds)    
    };  
    let paramsCases: IParamsCollection = { page: { number: 1, size: 2000}}
    //creamos filtros
    paramsCases.filter = FilterBuilder.fromObject(filtersCases).build();
    var contractProcessorsAll = await firstValueFrom(this.contractProcessorsService.all(paramsCases)).then(response => response.data);
    
    this.usersSameContractsIds = contractProcessorsAll.filter((v, i, a) => a.findIndex(t => (t.processorId === v.processorId)) === i).map(cp => cp.processorId);

    //añadimos a el mismo
    this.usersSameContractsIds.push(user.id);
        
    this.hasLoadedProcessorContracts = true;
  }

  async loadTasks() {
    if(!this.hasLoadedProcessorContracts){
      //cargamos los tramitadorse de la gente que esta en mis mismos contratos-
      await  this.loadProcessorContracts();
    }
    let user = this.storage.get('user');
    let endOfToday = new Date();
    endOfToday.setHours(23, 59, 59, 0);
    let today = this.formatDateTime(endOfToday);

    let filters: any = {
      isCompleted: new Filter(FilterOperation.equals, 'isCompleted'),
      date : new Filter(FilterOperation.lessOrEqual, 'date', '', today) //Monstramos el total de las de hoy, no de cualquiera futura
    };

    if(this.usersSameContractsIds.length > 0){
      //filtro de gente ausente
      filters['userId'] = new OrFilter([
          new Filter(FilterOperation.equals, 'userId', '', user.id),
          new AndFilter([
            new Filter(FilterOperation.equals, 'user.absence', '', true),
            new Filter(FilterOperation.any, 'userId', '', (this.usersSameContractsIds.length>0?this.usersSameContractsIds:null))
          ])
      ]);
    }else{
      filters['userId'] = new Filter(FilterOperation.equals, 'userId', '', user.id);
    }
    filters.isCompleted.value = false;

    let params: IParamsCollection = {
      page: { size: 1000 },
      filter: FilterBuilder.fromObject(filters).build()
    }

    let response = await firstValueFrom(this.tasksService.all(params, true));
    this.pendingTasksCount = response.meta['total'];
    this.updatePendingTasksCount();
    setTimeout(() => {
      this.loadTasks();
    }, 5 * 60 * 1000);
  }

  async loadMailAccounts() {
    let filters:any = {
      IMAPEnabled: new Filter( FilterOperation.equals, 'imapEnabled', '', true),
      AllowMailboxViewer: new Filter( FilterOperation.equals, 'allowMailboxViewer', '', true),
      unreadMailsCount: new Filter( FilterOperation.greaterThan, 'unreadMailsCount', '', 0)
    };
    let params:IParamsCollection = {
      page: { number: 1, size: 1000 },
      filter: FilterBuilder.fromObject(filters).build()
    }                
    let response = await firstValueFrom(this.mailAccountsService.all(params, true));
    let newUnseanMails = 0;
    response.data.forEach((item: any) => {
      newUnseanMails += item.unreadMailsCount;
    });
    this.unseanMails = newUnseanMails;
    this.updateUnseanMailCount();
    setTimeout(() => {
      this.loadMailAccounts();
    }, 5 * 60 * 1000);
  }

  updatePendingTasksCount() {
    this.setBadgeById('menu-tasks', this.pendingTasksCount);
  }

  /// Pone el contador de una entrada del menú buscándola por su identificador.
  ///
  /// Antes se localizaba comparando el texto visible ('Asistencia' y 'Buzones de correo'), de modo que renombrar
  /// una entrada del menú dejaba el contador sin actualizarse y sin ningún aviso. Se recorre el árbol completo y
  /// se devuelve un array nuevo, porque el componente de menú de PrimeNG solo repinta si cambia la referencia.
  private setBadgeById(id: string, value: number) {
    const apply = (items: MenuItem[] | undefined): MenuItem[] | undefined => items?.map(item => {
      const updated: MenuItem = { ...item };
      if (updated.id === id) updated.badge = '' + value;
      if (updated.items) updated.items = apply(updated.items);
      return updated;
    });

    this.items = apply(this.items) ?? [];
    this.buildSections();
  }

  private buildSections() {
    const byIds = (ids: string[]) => this.items.filter(item => ids.includes(item.id!));
    this.sections = this.sectionLayout
      .map(section => ({ label: section.label, items: byIds(section.ids) }))
      .filter(section => section.items.some(item => item.visible !== false));
    this.bottomItems = byIds(this.bottomIds);
  }

  updateUnseanMailCount() {
    this.setBadgeById('menu-mailbox', this.unseanMails);
  }

  onGroupClick(item: MenuItem) {
    this.menus.forEach(menu => {
      if (!menu.model?.some(modelItem => modelItem.id === item.id)) {
        menu.collapseAll();
      }
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.sidebarService.isExpanded() && !this.elementRef.nativeElement.contains(event.target)) {
      this.menus?.forEach(menu => menu.collapseAll());
    }
  }

  trackSection(index: number, section: { label?: string }) {
    return section.label ?? index;
  }

  collapseAll() {
    if (!this.sidebarService.isExpanded()) {
      this.menus.forEach(menu => menu.collapseAll());
      //this.sidebarService.toogle();
    } else {
    }
    //al pulsar una opción final del menú, subimos la página al principio
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  goToUrl(url:string){
    window.open(url, '_blank');
  }

  private formatDateTime(date: Date): string {
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0');
    let day = String(date.getDate()).padStart(2, '0');
    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');
    let seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  logout() {
    this.loginService.logout();
  }

  toogleMenu(element: ElementRef) {
    //console.log(element);
  }

}
